import React, { Component } from "react";
import logo from "@/assets/images/logo.png";
class Nav extends Component {
  state = {
    visible: false,
    background_is_black: true,
    select_index: 0,
  };
  componentDidMount() {
    if(this.props.navIndex){
      this.setState({
        select_index:this.props.navIndex
      })
    }
    this.props.onRef(this);
  }
  //   submit = () => {
  //     this.props.navIndex(1212);
  //     console.log(this.props.navList);
  //   };
  //语言切换
  langChange = () => {
    this.props.langChange();
    // console.log(this.refDom.clientWidth);
  };
  //   跳转页面
  toPage(e, index) {
    this.props.toPageSwiper(index);
  }
  //点击logo
  toLogoClick(e) {
    // console.log(this.props)
    this.props.logoClick();
  };
  //   跳转页面
  toSecondPage(e, page) {
    this.props.toSecondPage(page);
  }
  render() {
    const navList = JSON.parse(this.props.navList);
    const navListLevel = JSON.parse(this.props.navListLevel);
    const { background_is_black, select_index } = this.state;
    // const lang = this.props.lang;
    const isHomePage = this.props.isHomePage;
    const className = this.props.className;
    // console.log(background_is_black);
    return (
      <div
        className={`nav_container ${className ? className : ""} ${
          background_is_black ? "background_black" : "background_white"
        } ${isHomePage ? "" : ""}`}
      >
        {/* <button onClick={this.submit}>传值</button> */}
        <div
          ref={(ref) => {
            this.refDom = ref;
          }}
          className="logo_container"
        >
          <img
            src={logo}
            alt=""
            style={{ height: "40px", cursor: "pointer" }}
            onClick={(e) => this.toLogoClick(e)}
          />
        </div>
        <div className="nav_list">
          <div className="nav">
            {navList.map((val, index) => (
              <div
                className={`${index === 2?'nav-level':''} ${select_index === index ? "nav_selected" : ""}`}
                key={index}
              >
                <div onClick={(e) => this.toPage(e, index)}>{val}</div>
                {index === 2?(
                  <div className="nav-level-container">
                    <div onClick={(e) => this.toSecondPage(e, "CBU")}>{navListLevel[0]}</div>
                    <div onClick={(e) => this.toSecondPage(e, "EBU")}>{navListLevel[1]}</div>
                  </div>
                ):null}
              </div>
            ))}
            {/* <img
              className="langChange"
              src={
                require(`@/assets/images/${lang === "zh_cn" ? "en" : "cn"}_${
                  background_is_black ? "white" : "black"
                }.png`).default
              }
              alt=""
              onClick={this.langChange}
            /> */}
          </div>
        </div>
      </div>
    );
  }
}
export default Nav;
